export default __webpack_public_path__ + "static/media/freeSupoort.d14c9d6c.png";